<template>
<v-container >
<v-card light color="secondary" elevation="11">
  <v-card-title>
    <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('search')"
        single-line
        hide-details
        outlined
        class="tertiary"
      ></v-text-field>
      </v-card-title>
      <v-data-table
    :headers="headers"
    :items="selectedproducts"
    sort-by="name"
    :search="search"
    class="tertiary ma-2 pa-2"
  >
    
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        small
        class="mr-2 pa-1 success black--text font-weight-black"
        @click="choosePrice(item)"
      >{{ $t('sell') }}</v-btn>
      <v-dialog :retain-focus='false' width="550px" v-model="errorInvQty">
              <errorMessage @close="errorInvQty=false" :title="'Error'" :message="$t('sellScreen.errorQtyProd')" :key="errorKey"/>
            </v-dialog>
      
    </template>
    <template v-slot:[`item.codigo`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4 ">{{ item.codigo }}</h3></v-row>      
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4">{{ item.name }}</h3>   </v-row>   
    </template>
    <template v-slot:[`item.desc`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4">{{ item.desc }}</h3>  </v-row>    
    </template>
    <template v-slot:[`item.pu_buy`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4">{{ item.pu_buy }}</h3>   </v-row>   
    </template>
    <template v-slot:[`item.pu_sell`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4">{{ item.pu_sell }}</h3>  </v-row>    
    </template>
    <template v-slot:[`item.currenttInv`]="{ item }">
      <v-row class="justify-center"><h3 class="grey--text text--darken-4">{{ item.currenttInv }}</h3> </v-row>     
    </template>
    
  </v-data-table>  
  <v-dialog v-model="choosePriceVenta" max-width="80%" :retain-focus="false">
            <v-card>
        <v-card-title class="primary justify-center"><h1 class="textTitle--text ma-2 pa-2">{{ $t('prodselector2.choosePrice') }}</h1></v-card-title>
        <div v-for="price in pricelist" :key="price.name">
          <v-row  class="tertiary align-center">
          <v-col cols="6">
            <div class="ma-3 pa-2"><h2 class="text-center">{{ $t('prodselector2.resumePrice', { '1': price.name, '2': price.value, '3': price.qty }) }}</h2></div>
          </v-col>
          <v-col cols="6">
            <v-row class="justify-center">
              <v-icon class="mx-2" @click="minusQty()">mdi-minus</v-icon>
            <v-text-field min=0 :max="selectedProd.currenttInv" class="font-weight-black shrink" type="number" :value="price.qty" v-model.number="qtyProd"></v-text-field>
            <v-icon class="mx-2" @click="masQty()">mdi-plus</v-icon>
            </v-row>
            <v-row justify="center">
              <v-btn class="ma-2 pa-2 success black--text font-weight-black" @click="confirmPrice(price)">{{ $t('confirm') }}</v-btn>
            </v-row>
            
          </v-col>
          
        </v-row>
        <v-divider></v-divider>
        </div>
        
        
      </v-card>
    </v-dialog>
</v-card>

</v-container>
</template>

<script>
import errorMessage from '@/components/errorMessage'

  export default {
      props:['selectedproducts'],
      components:{errorMessage},
    data () {
      return {
        dialog: false,
        choosePriceVenta:false,
        pricelist:[],
        qtyProd:0,
        selectedprice:{},
        selectedProd:{},
        search:'',
        errorInvQty:false,
        errorKey:0,
      dialogDelete: false,
      
      }
    },
    computed: {
     headers(){
       var headers= [
        { text: this.$t('headers.actions'), value: 'actions', sortable: false,class: 'quaterny text--text font-weight-black text-subtitle-2' },
              {
                text: this.$t('headers.prodCode'),
                align: 'start',
                value: 'codigo',
                class: 'quaterny text--text font-weight-black text-subtitle-2'
              },
              {
                text: this.$t('headers.prodName'),
                align: 'start',
                value: 'name',

                class: 'quaterny text--text font-weight-black text-subtitle-2'
              },
              { text: this.$t('headers.prodDesc'), value: 'desc', sortable:false,class: 'quaterny text--text font-weight-black text-subtitle-2' },
              { text: this.$t('headers.prodPubuy'), value: 'pu_buy',class: 'quaterny text--text font-weight-black text-subtitle-2' },
              { text: this.$t('headers.prodPusell'), value: 'pu_sell',class: 'quaterny text--text font-weight-black text-subtitle-2' },
              { text: this.$t('headers.prodAvail'), value: 'currenttInv',class: 'quaterny text--text font-weight-black text-subtitle-2' }
      ]
      return headers
     }
    },
    mounted(){

    },
    methods: {
      masQty(){
         if(this.qtyProd<this.selectedProd.currenttInv){
        this.qtyProd+=1}
        console.log(this.selectedProd)
      },
      minusQty(){
        if(this.selectedProd.qty>0){
        this.selectedProd.qty-=1}
      },
        confirmPrice(price){
          var v = JSON.parse(JSON.stringify(this.selectedProd))
          
          var prod={id:v.id,codigo:v.codigo,name:v.name,qty:this.qtyProd,pu:price.value,total:0,currenttInv:v.currenttInv}
          this.$emit('addcart',prod)
          this.qtyProd=0
          
          this.choosePriceVenta=false
        },
      choosePrice(item){
        this.selectedProd=item
        if(item.currenttInv>0){
        this.pricelist=[]
        this.pricelist.push({name:this.$t('prodselector2.labelRegularPrice'),value:item.pu_sell,qty:1})
        if(item.price_mayor_sell){
        for(var i =0;i<item.price_mayor_sell.length;i++){
          this.pricelist.push({name:this.$t('prodselector2.labelSpecialPrice')+(i+1),value:item.price_mayor_sell[i].pu,qty:item.price_mayor_sell[i].qty})
        }}
        this.choosePriceVenta=true}else{this.errorInvQty=true}
      },

      
    },
  }
</script>